<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
        <b-row>
          <b-col cols="3">
            <h3><feather-icon size="22" icon="ClockIcon" /> سجل التتبع</h3>

          </b-col>
          <b-col cols="9">
            <div class="d-flex justify-content-end align-items-center" >
              <search-input
                placeholder="بحث بحسب المستخدم الذي قام بالتعديل "
                v-model="searchKey.full_name"
                class="mb-0 w-25 mx-1"
              />
              <search-input
                placeholder="بحث بحسب القسم الذي تم التعديل فيه"
                v-model="searchKey.filter"
                class="mb-0 w-25"
              />
              <form-mask
                options="date"
                placeholder="بحث بحسب تاريخ التعديل"
                v-model="searchKey.created_at"
                class="mt-1 w-25 mx-1"
              />
            </div>

          </b-col>
          
        </b-row>
        <hr />
        <data-table ep="v2/ministry/logs" :fields="logTableFields"  ref="logsTable" exportable>
          <template #cell(created_at)="{ item }">
            <div>
              {{ formatDateToHuman(item.created_at) }}
            </div>
          </template>
        </data-table>
    </b-card>

  </div>
  
  
</template>

<script>
import { BRow, BButton, BCol, BContainer , BCard } from "bootstrap-vue";
import DataTable from "@/components/data-table/index.vue";
import { formatDateToHuman } from "@/@core/utils/filter";
import SearchInput from "@/components/SearchInput.vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import debounce from "lodash.debounce";
import FormMask from "@/components/form-mask";
export default {
  components: {
    BRow,
    BButton,
    BCol,
    BContainer,
    DataTable,
    BCard , 
    SearchInput ,
    MinistryBreadcrumbs ,
    FormMask
  },
  data() {
    return {
      mainTitle: "سجل التتبع",
      confirmed: "P",
      breadcrumbs: [
        {
          text: "سجل التتبع",
          active: true,
        },
      ],
      searchKey: {},
      logTableFields: [
        {
          key: "creator.full_name",
          label: "المستخدم الذي قام بالتعديل",
          sortable: true,
        },
        {
          key: "operation",
          label: "القسم الذي تم فيه التعديل",
          sortable: true,
        },
        { key: "created_at", label: "تاريخ التعديل", sortable: true },
      ],
    };
  },
  methods: {
    formatDateToHuman,
  },
  watch: {
    searchKey: {
      deep: true,
      handler: debounce(function (value) {
        this.$refs.logsTable.setQueryParams(this.searchKey);
        this.$refs.logsTable.refreshTable();
      }, 300),
    },
  },
};
</script>
